
import React, { memo, useContext, useEffect, useState } from "react";
import LoadMachine from "../../../../../../components/dashboard/tab1Component/LoadMachine";
import "./DashboardTap4Content.css";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme } from '@mui/material';
import Solarpic from "../../../../../../assets/img/logos/solarpic.png";
import Load from "../../../../../../assets/img/logos/load.png";
import Grid1 from "../../../../../../assets/img/logos/grid.png";
import Watch from "../../../../../../assets/img/logos/solar_dg.jpg";

import { logApi, MainSumApi } from "../../../../../../api/Api";

import TempInfoWms from '../../../../../../components/dashboard/TempInfoWms';

import { InverterContext } from '../../../../../../context/InverterContext';
import { AppThemeContext } from '../../../../../../context/AppThemeContext';
import backgroundImage from '../../../../../../assets/img/bg/chart2.png';
import { AuthenticationContext } from '../../../../../../context/AuthenticationContext'

import SettingsIcon from '@mui/icons-material/Settings';

import AutorenewIcon from '@mui/icons-material/Autorenew';
import PolarAreaChart from "../../../../../../components/charts/tab2Chart/PolarAreaChart";
import SolarSvg2 from "../../../../../../assets/svg/lastSolarSvg2";
import MainSlider from "./MainSlider";
import BottomSlider from "./BottomSlider";
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../utils'
import PlantEnergy from "./plantEnergy/PlantEnergy";
import AppModal from "../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../components/inverter/InvverterFullSize";
import Load3Svg from "../../../../../../assets/svg/Load3Svg";
import SvgImage1 from "./svgImagDashboard/SvgImage1";
import Load1SvgImage from "./svgImagDashboard/Load1SvgImage";
import Load2SvgImage from "./svgImagDashboard/Load2SvgImage";
import Load3SvgImage from "./svgImagDashboard/Load3SvgImage";
import Tab4MonthlyEnergy from "./tab4MonthlyEnergy/Tab4MonthlyEnergy";
import SvgHybridImage from "./svgImagDashboard/SvgHybridImage";
import Load1Svg from "../../../../../../assets/svg/Load1Svg";
import SolarGrid1 from "../../../../../../assets/svg/SolarGrid1";
import SingleSolarGrid from "./svgImagDashboard/SingleSolarGrid";
import SingleSolarLoad from "./svgImagDashboard/SingleSolarLoad";
import PrBottomChart from "./prbottomChart/PrbottomChart";
import PlantEnergyKusum from "./plantEnergy/PlantEnergyKusum/PlantEnergyKusum";



// 1.

// function DashboardTap4Content() {
//     const { LoggedInUserInfo, USER_CATEGORY } = React.useContext(AuthenticationContext)

//     const { PrimaryColor } = useContext(AppThemeContext);

//     const { spacing, palette, shape: { borderRadius } } = useTheme();
//     const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

//     const [logData, setLogData] = useState([]);
//     const [mainData, setMainData] = useState([]);
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID"),
//         LOC_CODE: localStorage.getItem("LCODE"),
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });


//     const [sumCredentials, setSumCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         PASS_KEY: localStorage.getItem("KEY") || "xyz",
//         LCODE: localStorage.getItem("LCODE") || "",
//         DT1: StartDate,
//         DT2: EndDate,
//         TYP: "A",
//         WEB_KEY: "WEBXYZ321",
//         FID: "216HT001",
//     });



//     // this is fetching for MIDDLE data
//     const fetchLogData = async () => {
//         const res = await logApi(credentials);
//         if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//             setLogData(res.TOT_LIVE_KW_NEW);
//         } else {
//             setLogData([]);
//         }
//     };

//     // useEffect(() => {
//     //     fetchLogData();
//     // }, [credentials]); // Fetch new data when credentials change


//     // this is fetching for MAIN_SUM
//     const fetchData = async () => {
//         const res = await MainSumApi(sumCredentials);
//         if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
//             setMainData(res.KWH_MIS_MAIN_SUM);
//         } else {
//             setMainData([]);
//         }
//     };

//     // useEffect(() => {
//     //     fetchData();
//     // }, [sumCredentials]); // Fetch new data when credentials change

//     // console.log("LoggedInUserInfo",LoggedInUserInfo)

//     useEffect(() => {
//         // Fetch data immediately on mount
//         fetchLogData();
//         fetchData();

//         // Set interval to fetch data every 30 seconds
//         const interval = setInterval(() => {
//             fetchLogData();
//             fetchData();
//         }, 70000); // 70 seconds in milliseconds

//         // Cleanup interval on unmount
//         return () => clearInterval(interval);
//     }, [credentials, sumCredentials]); // Dependencies to trigger re-setup if these values change



//     const blinkingAnimationDateTime = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//     }
//     const blinkingAnimationBatteryStatusCharging = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//         color: 'green'
//     }
//     const blinkingAnimationBatteryStatusDischarging = {
//         fontWeight: "900",
//         animation: 'blinkingAnimationDateTime 2s infinite',
//         transition: 'color 0.5s ease-in-out',
//         color: 'red'
//     }

//     const styles = {
//         IconStyle: {
//             color: 'primary.main',
//             fontSize: '1rem'
//         }
//     }

//     return (

//         <>
//             {LoggedInUserInfo.MNU_WMS === "1" && LoggedInUserInfo.USER_CATEGORY !== "WMS" && (
//                 <TempInfoWms />
//             )}


//             <div className="w-100 " style={{ backgroundColor: "white" }}>
//                 <div className="row g-0"> {/* Use g-0 to remove horizontal gaps */}

//                     <div className="col g-1">
//                         <div className="first_total">
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Annual Target</strong>
//                                 </div>
//                                 <div className="card-body px-2">
//                                     {mainData.map((item, indx) => (
//                                         <div className="text-start" key={indx}>
//                                             <p>Target&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                 {item.Target !== undefined ? item.Target : "N/A"}
//                                             </span>&nbsp;
//                                                 <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>



//                                             <p>Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                 {item.Achieved !== undefined ? item.Achieved : "N/A"}
//                                             </span>&nbsp;
//                                                 <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>


//                                             <p>Target&nbsp;Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                 {item.Achieved_per !== undefined ? item.Achieved_per : "N/A"}
//                                             </span>
//                                             </p>

//                                         </div>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="col g-1">
//                         <div className="first_total">
//                             <div className="card text-center">
//                                 <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                     <strong>Solar Yield</strong>
//                                 </div>
//                                 <div className="card-body px-2">
//                                     <div>
//                                         <img
//                                             style={{ display: "flex", marginBottom: "1rem" }}
//                                             src={Solarpic}
//                                             alt="Solarpic"
//                                             className="dashboard-icon"
//                                         />

//                                         {logData.map((log, index) => (
//                                             <div className='d-flex align-items-center' key={index}>
//                                                 <p style={{ fontSize: "14px" }}>
//                                                     <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                         {log.SOLAR !== undefined ? log.SOLAR : "N/A"}
//                                                     </span>&nbsp;
//                                                     <span style={{ color: "red" }}>kW</span>
//                                                 </p>
//                                             </div>
//                                         ))}
//                                     </div>
//                                     {/* {logData.map((log, index) => (
//                                         <div className='d-flex align-items-center' key={index}>
//                                             <p style={{ fontSize: "14px" }}>
//                                                 <span style={{ fontSize: "1.4rem" }}>
//                                                     {log.SOLAR !== undefined ? log.SOLAR : "N/A"}
//                                                 </span>{" "}
//                                                 kW
//                                             </p>
//                                         </div>
//                                     ))} */}

//                                     {mainData.map((item, indx) => (
//                                         <div className="text-end" key={indx}>
//                                             <p>Today Yield</p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.SOLAR_DAY !== undefined ? item.SOLAR_DAY : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>
//                                             <p>Total Yield</p>
//                                             <p>
//                                                 <span className="bold" style={{ color: "#013b7b" }}>
//                                                     {item.SOLAR_TOTAL !== undefined ? item.SOLAR_TOTAL : "N/A"}&nbsp;

//                                                 </span>
//                                                 <span>kWh</span>
//                                             </p>

//                                         </div>
//                                     ))}


//                                 </div>
//                             </div>
//                         </div>
//                     </div>


//                     {!["SOLAR-LOAD"].includes(LoggedInUserInfo.USER_CATEGORY) && (
//                         <div className="col g-1">
//                             <div className="first_total">
//                                 <div className="card text-center">
//                                     <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                         <strong>Grid</strong>
//                                     </div>
//                                     <div className="card-body px-2">
//                                         <div><img style={{ display: "flex", marginBottom: "1rem" }} src={Grid1} alt="grid" className="dashboard-icon" />
//                                             {logData.map((log, index) => (
//                                                 <div className='d-flex align-items-start' key={index}><p style={{ fontSize: "14px" }}>
//                                                     <span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
//                                                         {log.GRID !== undefined ? log.GRID : "N/A"}
//                                                     </span>&nbsp;
//                                                     <span style={{ color: "red" }}>kW</span></p>
//                                                 </div>
//                                             ))}
//                                         </div>


//                                         {mainData.map((item, indx) => (
//                                             <div className="text-end" key={indx}>
//                                                 <p>Today Grid</p>
//                                                 <p>
//                                                     <span className="bold" style={{ color: "#013b7b" }}>
//                                                         {item.GRID_DAY !== undefined ? item.GRID_DAY : "N/A"}&nbsp;

//                                                     </span>
//                                                     <span>kWh</span>
//                                                 </p>
//                                                 <p>Total Grid</p>
//                                                 <p>
//                                                     <span className="bold" style={{ color: "#013b7b" }}>
//                                                         {item.GRID_TOTAL !== undefined ? item.GRID_TOTAL : "N/A"}&nbsp;

//                                                     </span>
//                                                     <span>kWh</span>
//                                                 </p>

//                                             </div>
//                                         ))}


//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {!["SOLAR_3_GRID", "HYBRID", "ZERO-EXPORT", "SOLAR-GRID", "SOLAR-LOAD"].includes(LoggedInUserInfo.USER_CATEGORY) && (
//                         <div className="col g-1">
//                             <div className="first_total">
//                                 <div className="card text-center">
//                                     <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                         <strong>DG</strong>
//                                     </div>
//                                     <div className="card-body px-2">
//                                         <div>
//                                             <img
//                                                 style={{ display: "flex", marginBottom: "1rem" }}
//                                                 src={Watch}
//                                                 alt="watch"
//                                                 className="dashboard-icon"
//                                             />
//                                             {logData.map((log, index) => (
//                                                 <div className='d-flex align-items-center' key={index}>
//                                                     <p style={{ fontSize: "14px" }}>
//                                                         <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                             {log.GenSet !== undefined ? log.GenSet : "N/A"}
//                                                         </span>&nbsp;
//                                                         <span style={{ color: "red" }}>kW</span>
//                                                     </p>
//                                                 </div>
//                                             ))}
//                                         </div>

//                                         {mainData.map((item, indx) => (
//                                             <div className="text-center" key={indx}>
//                                                 <p>Today</p>
//                                                 <p>
//                                                     <span className="bold" style={{ color: "#013b7b" }}>
//                                                         {item.DG_DAY !== undefined ? item.DG_DAY : "N/A"}&nbsp;
//                                                     </span>
//                                                     <span>kWh</span>
//                                                 </p>
//                                                 <p>Total</p>
//                                                 <p>
//                                                     <span className="bold" style={{ color: "#013b7b" }}>
//                                                         {item.DG_TOTAL !== undefined ? item.DG_TOTAL : "N/A"}&nbsp;
//                                                     </span>
//                                                     <span>kWh</span>
//                                                 </p>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     )}




//                     {!["SOLAR-GRID"].includes(LoggedInUserInfo.USER_CATEGORY) &&
//                         logData.map((log, index) => (
//                             <div className="col g-1" key={index}>
//                                 <div className="first_total">
//                                     <div className="card text-center">
//                                         <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                             <strong>Load</strong>
//                                         </div>
//                                         <div className="card-body px-2">
//                                             <div>
//                                                 <img
//                                                     style={{ display: "flex", marginBottom: "1rem" }}
//                                                     src={Load}
//                                                     alt="load"
//                                                     className="dashboard-icon"
//                                                 />
//                                                 <div className='d-flex align-items-center'>
//                                                     <p style={{ fontSize: "14px", display: "flex", alignItems: "center" }}>
//                                                         <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
//                                                             {log.TOTAL_LOAD !== undefined ? log.TOTAL_LOAD : "N/A"}
//                                                         </span>&nbsp;
//                                                         <span style={{ color: "red" }}>kW</span>
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))
//                     }






//                     {mainData.map((log, index) => (
//                         <div className="col g-1" key={index}>
//                             <div className="first_total">
//                                 <div className="card">
//                                     <div className="card-header text-center" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
//                                         <strong>Today's Performance</strong>
//                                     </div>
//                                     <div className="card-body px-3">

//                                         <div className="d-flex justify-content-start w-100">


//                                             <div className="leftdiv">
//                                                 <p><span>CUF</span> &nbsp;<span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                     {log.CUF !== undefined ? log.CUF : "N/A"}
//                                                 </span>&nbsp;
//                                                     <span className=""> PR</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log.PR !== undefined ? log.PR : "N/A"}
//                                                     </span>
//                                                 </p>


//                                                 <p><span>Expected[kWh]</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log["EXPECT_GEN[KWH]"] !== undefined ? log["EXPECT_GEN[KWH]"] : "N/A"}

//                                                     </span>
//                                                 </p>
//                                                 <p><span>Peak&nbsp;Irradiance[W/m²]</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log.PEAK_IRRADIANCE !== undefined ? log.PEAK_IRRADIANCE : "N/A"}
//                                                     </span>
//                                                 </p>
//                                                 <p><span>Peak&nbsp;Irr&nbsp;Time</span>&nbsp;
//                                                     <span style={{ fontSize: "1rem", color: "#013b7b" }}>
//                                                         {log.PEAK_IRR_TIME !== undefined ? log.PEAK_IRR_TIME : "N/A"}
//                                                     </span>
//                                                 </p>
//                                             </div>
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>
//                         </div>
//                     ))}

//                 </div>
//             </div>


//             {/* <SolarSvg1 svgColor={palette.primary.main} /> */}

//             <Grid container style={{ padding: "0", margin: "0" }}>

//                 < Grid item xs={12} sm={12} md={12} lg={6} xl={6} padding={spacing(0)} sx={{ display: "flex" }}>
//                     <Container
//                         sx={{
//                             maxWidth: '100%',
//                             width: '100%',
//                             position: 'relative',
//                             backgroundColor: '#f9f9f9',
//                             display: 'flex',
//                             justifyContent: 'center',
//                             alignItems: 'center',
//                             border: "1px solid lightgray",
//                             borderRadius: ".3rem",
//                             marginTop: '.4rem',
//                             marginRight: '.4rem'
//                         }}
//                     >
//                         <Box sx={{ width: '100%', height: '100%' }}>

//                             {LoggedInUserInfo?.USER_CATEGORY === "SOLAR_3_GRID" ? (
//                                 <Load3SvgImage />
//                             ) : LoggedInUserInfo?.USER_CATEGORY === "HYBRID" ? (
//                                 <SvgHybridImage />
//                             ) : LoggedInUserInfo?.USER_CATEGORY === "ZERO-EXPORT" ? (
//                                 <Load1SvgImage />
//                             ) : LoggedInUserInfo?.USER_CATEGORY === "SOLAR-GRID" ? (
//                                 <SingleSolarGrid />
//                             ) : LoggedInUserInfo?.USER_CATEGORY === "SOLAR-LOAD" ? (
//                                 <SingleSolarLoad />
//                             ) :
//                                 (
//                                     <SvgImage1 />
//                                 )
//                             }




//                         </Box>
//                     </Container>



//                 </Grid>





//                 <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ overflow: 'hidden' }}>

//                     <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
//                         {/* First Card */}
//                         <Stack
//                             component={Card}
//                             p={spacing(1)}
//                             sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
//                         >
//                             <MainSlider />
//                         </Stack>

//                         {/* Second Card */}
//                         {/* <Stack component={Card} p={spacing(1)} sx={{ height: '16rem', overflow: 'hidden' }}>

//                             <Tab4MonthlyEnergy />

//                         </Stack> */}
//                         <Tab4MonthlyEnergy />

//                     </Stack>


//                 </Grid>

//                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)} style={{ marginTop: '.4rem' }}>

//                     <Stack
//                         component={Card}
//                         p={spacing(1)}
//                         sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(1) }}
//                     >
//                         <PlantEnergy />
//                     </Stack>
//                 </Grid>
//                 {/* //PRBOTTOM CHART */}

//                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

//                     <Stack rowGap={spacing(0)} sx={{ marginTop: '0px', overflow: 'hidden' }}>
//                       <PrBottomChart/>

//                     </Stack>


//                 </Grid>


//             </Grid>

//             <BottomSlider />

//         </>
//     );
// }


// export default memo(DashboardTap4Content)



// 2.

function DashboardTap4Content() {
    const { LoggedInUserInfo, USER_CATEGORY } = React.useContext(AuthenticationContext)

    const { PrimaryColor } = useContext(AppThemeContext);

    const { spacing, palette, shape: { borderRadius } } = useTheme();
    const { getHYBRD_Info, HYBRD_DATA_POWER_Loading, HYBRD_DATA_INFO, getPostKwhHybridForDashboard, getHYBRD_Power, HYBRD_DATA_POWER, POST_KWH_HYBRID_DATA_DASHBOARD } = useContext(InverterContext);

    const [logData, setLogData] = useState([]);
    const [mainData, setMainData] = useState([]);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
        WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
    });


    const [sumCredentials, setSumCredentials] = useState({
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE") || "",
        DT1: StartDate,
        DT2: EndDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
    });



    // this is fetching for MIDDLE data
    const fetchLogData = async () => {
        const res = await logApi(credentials);
        if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
            setLogData(res.TOT_LIVE_KW_NEW);
        } else {
            setLogData([]);
        }
    };

    // useEffect(() => {
    //     fetchLogData();
    // }, [credentials]); // Fetch new data when credentials change


    // this is fetching for MAIN_SUM
    const fetchData = async () => {
        const res = await MainSumApi(sumCredentials);
        if (res?.KWH_MIS_MAIN_SUM && Array.isArray(res.KWH_MIS_MAIN_SUM)) {
            setMainData(res.KWH_MIS_MAIN_SUM);
        } else {
            setMainData([]);
        }
    };



    // useEffect(() => {
    //     // Fetch data immediately on mount
    //     fetchLogData();
    //     fetchData();

    //     // Set interval to fetch data every 70 seconds
    //     const interval = setInterval(() => {
    //         fetchLogData();
    //         fetchData();
    //     }, 60000); // 70 seconds in milliseconds

    //     // Cleanup interval on unmount
    //     return () => clearInterval(interval);
    // }, [credentials, sumCredentials]); 

    // ---------- 1) fetchLogData → refresh every 60 sec ----------
    useEffect(() => {
        // run on mount + when dependency changes
        fetchLogData();

        const interval = setInterval(() => {
            fetchLogData();
        }, 60000); // 60 sec

        return () => clearInterval(interval);
    }, [credentials, sumCredentials]);


    // ---------- 2) fetchData → refresh every 5 min ----------
    useEffect(() => {
        // run on mount + when dependency changes
        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 300000); // 5 minutes = 300000 ms

        return () => clearInterval(interval);
    }, [credentials, sumCredentials]);


    const blinkingAnimationDateTime = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
    }
    const blinkingAnimationBatteryStatusCharging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'green'
    }
    const blinkingAnimationBatteryStatusDischarging = {
        fontWeight: "900",
        animation: 'blinkingAnimationDateTime 2s infinite',
        transition: 'color 0.5s ease-in-out',
        color: 'red'
    }

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '1rem'
        }
    }

    return (

        <>
            {LoggedInUserInfo.MNU_WMS === "1" && LoggedInUserInfo.USER_CATEGORY !== "WMS" && (
                <TempInfoWms />
            )}


            <div className="w-100 " style={{ backgroundColor: "white" }}>
                <div className="row g-0"> {/* Use g-0 to remove horizontal gaps */}

                    <div className="col g-1">
                        <div className="first_total">
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Annual Target</strong>
                                </div>
                                <div className="card-body px-2">
                                    {mainData.map((item, indx) => (
                                        <div className="text-start" key={indx}>
                                            <p>Target&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                {item.Target !== undefined ? item.Target : "N/A"}
                                            </span>&nbsp;
                                                <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>



                                            <p>Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                {item.Achieved !== undefined ? item.Achieved : "N/A"}
                                            </span>&nbsp;
                                                <span style={{ color: "red" }}>{item.Target_unit !== undefined ? item.Target_unit : "N/A"}</span></p>


                                            <p>Target&nbsp;Achieved&nbsp;:&nbsp;<span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                {item.Achieved_per !== undefined ? item.Achieved_per : "N/A"}
                                            </span>
                                            </p>

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col g-1">
                        <div className="first_total">
                            <div className="card text-center">
                                <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                    <strong>Solar Yield</strong>
                                </div>
                                <div className="card-body px-2">
                                    <div>
                                        <img
                                            style={{ display: "flex", marginBottom: "1rem" }}
                                            src={Solarpic}
                                            alt="Solarpic"
                                            className="dashboard-icon"
                                        />

                                        {logData.map((log, index) => (
                                            <div className='d-flex align-items-center' key={index}>
                                                <p style={{ fontSize: "14px" }}>
                                                    <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                        {log.SOLAR !== undefined ? log.SOLAR : "N/A"}
                                                    </span>&nbsp;
                                                    <span style={{ color: "red" }}>kW</span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                    {/* {logData.map((log, index) => (
                                        <div className='d-flex align-items-center' key={index}>
                                            <p style={{ fontSize: "14px" }}>
                                                <span style={{ fontSize: "1.4rem" }}>
                                                    {log.SOLAR !== undefined ? log.SOLAR : "N/A"}
                                                </span>{" "}
                                                kW
                                            </p>
                                        </div>
                                    ))} */}

                                    {mainData.map((item, indx) => (
                                        <div className="text-end" key={indx}>
                                            <p>Today Yield</p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.SOLAR_DAY !== undefined ? item.SOLAR_DAY : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>
                                            <p>Total Yield</p>
                                            <p>
                                                <span className="bold" style={{ color: "#013b7b" }}>
                                                    {item.SOLAR_TOTAL !== undefined ? item.SOLAR_TOTAL : "N/A"}&nbsp;

                                                </span>
                                                <span>kWh</span>
                                            </p>

                                        </div>
                                    ))}


                                </div>
                            </div>
                        </div>
                    </div>


                    {!["SOLAR-LOAD"].includes(LoggedInUserInfo.USER_CATEGORY) && (
                        <div className="col g-1">
                            <div className="first_total">
                                <div className="card text-center">
                                    <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                        <strong>Grid</strong>
                                    </div>
                                    <div className="card-body px-2">
                                        <div><img style={{ display: "flex", marginBottom: "1rem" }} src={Grid1} alt="grid" className="dashboard-icon" />
                                            {logData.map((log, index) => (
                                                <div className='d-flex align-items-start' key={index}><p style={{ fontSize: "14px" }}>
                                                    <span style={{ fontSize: "1.2rem", color: "#013b7b" }}>
                                                        {log.GRID !== undefined ? log.GRID : "N/A"}
                                                    </span>&nbsp;
                                                    <span style={{ color: "red" }}>kW</span></p>
                                                </div>
                                            ))}
                                        </div>


                                        {mainData.map((item, indx) => (
                                            <div className="text-end" key={indx}>
                                                <p>Today Grid</p>
                                                <p>
                                                    <span className="bold" style={{ color: "#013b7b" }}>
                                                        {item.GRID_DAY !== undefined ? item.GRID_DAY : "N/A"}&nbsp;

                                                    </span>
                                                    <span>kWh</span>
                                                </p>
                                                <p>Total Grid</p>
                                                <p>
                                                    <span className="bold" style={{ color: "#013b7b" }}>
                                                        {item.GRID_TOTAL !== undefined ? item.GRID_TOTAL : "N/A"}&nbsp;

                                                    </span>
                                                    <span>kWh</span>
                                                </p>

                                            </div>
                                        ))}


                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {!["SOLAR_3_GRID", "HYBRID", "ZERO-EXPORT", "SOLAR-GRID", "SOLAR-LOAD"].includes(LoggedInUserInfo.USER_CATEGORY) && (
                        <div className="col g-1">
                            <div className="first_total">
                                <div className="card text-center">
                                    <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                        <strong>DG</strong>
                                    </div>
                                    <div className="card-body px-2">
                                        <div>
                                            <img
                                                style={{ display: "flex", marginBottom: "1rem" }}
                                                src={Watch}
                                                alt="watch"
                                                className="dashboard-icon"
                                            />
                                            {logData.map((log, index) => (
                                                <div className='d-flex align-items-center' key={index}>
                                                    <p style={{ fontSize: "14px" }}>
                                                        <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                            {log.GenSet !== undefined ? log.GenSet : "N/A"}
                                                        </span>&nbsp;
                                                        <span style={{ color: "red" }}>kW</span>
                                                    </p>
                                                </div>
                                            ))}
                                        </div>

                                        {mainData.map((item, indx) => (
                                            <div className="text-center" key={indx}>
                                                <p>Today</p>
                                                <p>
                                                    <span className="bold" style={{ color: "#013b7b" }}>
                                                        {item.DG_DAY !== undefined ? item.DG_DAY : "N/A"}&nbsp;
                                                    </span>
                                                    <span>kWh</span>
                                                </p>
                                                <p>Total</p>
                                                <p>
                                                    <span className="bold" style={{ color: "#013b7b" }}>
                                                        {item.DG_TOTAL !== undefined ? item.DG_TOTAL : "N/A"}&nbsp;
                                                    </span>
                                                    <span>kWh</span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}




                    {!["SOLAR-GRID"].includes(LoggedInUserInfo.USER_CATEGORY) &&
                        logData.map((log, index) => (
                            <div className="col g-1" key={index}>
                                <div className="first_total">
                                    <div className="card text-center">
                                        <div className="card-header" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                            <strong>Load</strong>
                                        </div>
                                        <div className="card-body px-2">
                                            <div>
                                                <img
                                                    style={{ display: "flex", marginBottom: "1rem" }}
                                                    src={Load}
                                                    alt="load"
                                                    className="dashboard-icon"
                                                />
                                                <div className='d-flex align-items-center'>
                                                    <p style={{ fontSize: "14px", display: "flex", alignItems: "center" }}>
                                                        <span style={{ fontSize: "1.4rem", color: "#013b7b" }}>
                                                            {log.TOTAL_LOAD !== undefined ? log.TOTAL_LOAD : "N/A"}
                                                        </span>&nbsp;
                                                        <span style={{ color: "red" }}>kW</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }






                    {mainData.map((log, index) => (
                        <div className="col g-1" key={index}>
                            <div className="first_total">
                                <div className="card">
                                    <div className="card-header text-center" style={{ backgroundColor: PrimaryColor, color: 'white', padding: "2px" }}>
                                        <strong>Today's Performance</strong>
                                    </div>
                                    <div className="card-body px-3">

                                        <div className="d-flex justify-content-start w-100">


                                            <div className="leftdiv">
                                                <p><span>CUF</span> &nbsp;<span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                    {log.CUF !== undefined ? log.CUF : "N/A"}
                                                </span>&nbsp;
                                                    <span className=""> PR</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log.PR !== undefined ? log.PR : "N/A"}
                                                    </span>
                                                </p>


                                                <p><span>Expected[kWh]</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log["EXPECT_GEN[KWH]"] !== undefined ? log["EXPECT_GEN[KWH]"] : "N/A"}

                                                    </span>
                                                </p>
                                                <p><span>Peak&nbsp;Irradiance[W/m²]</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log.PEAK_IRRADIANCE !== undefined ? log.PEAK_IRRADIANCE : "N/A"}
                                                    </span>
                                                </p>
                                                <p><span>Peak&nbsp;Irr&nbsp;Time</span>&nbsp;
                                                    <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                        {log.PEAK_IRR_TIME !== undefined ? log.PEAK_IRR_TIME : "N/A"}
                                                    </span>
                                                </p>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    ))}


                    {LoggedInUserInfo?.TAB_REVENUE === "1" &&
                        mainData.map((log, index) => (
                            <div className="col g-1" key={index}>
                                <div className="first_total">
                                    <div className="card">
                                        <div
                                            className="card-header text-center"
                                            style={{
                                                backgroundColor: PrimaryColor,
                                                color: "white",
                                                padding: "2px",
                                            }}
                                        >
                                            <strong>
                                                Revenue Gains ({LoggedInUserInfo?.CURRENCY})
                                            </strong>
                                        </div>

                                        <div className="card-body px-3">
                                            <div className="d-flex justify-content-start w-100">
                                                <div className="leftdiv">

                                                    <p>
                                                        <span>Day</span> &nbsp;&nbsp;
                                                        <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                            {log.Day_Rev ?? "N/A"}
                                                        </span>
                                                    </p>

                                                    <p>
                                                        <span>Month</span>&nbsp;&nbsp;
                                                        <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                            {log.Month_Rev ?? "N/A"}
                                                        </span>
                                                    </p>

                                                    <p>
                                                        <span>Year</span>&nbsp;&nbsp;
                                                        <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                            {log.Year_Rev ?? "N/A"}
                                                        </span>
                                                    </p>

                                                    <p>
                                                        <span>Rate</span>&nbsp;&nbsp;
                                                        <span style={{ fontSize: "1rem", color: "#013b7b" }}>
                                                            {log.RATE ?? "N/A"} {LoggedInUserInfo?.CURRENCY}/kWh
                                                        </span>
                                                    </p>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        ))
                    }

                </div>
            </div>


            {/* <SolarSvg1 svgColor={palette.primary.main} /> */}

            <Grid container style={{ padding: "0", margin: "0" }}>

                < Grid item xs={12} sm={12} md={12} lg={6} xl={6} padding={spacing(0)} sx={{ display: "flex" }}>
                    <Container
                        sx={{
                            maxWidth: '100%',
                            width: '100%',
                            position: 'relative',
                            // backgroundColor: '#f9f9f9',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            // border: "1px solid lightgray",
                            border: "1px solid #eee",
                            borderRadius: ".3rem",
                            marginTop: '.4rem',
                            marginRight: '.4rem'
                        }}
                    >
                        <Box sx={{ width: '100%', height: '100%' }}>

                            {LoggedInUserInfo?.USER_CATEGORY === "SOLAR_3_GRID" ? (
                                <Load3SvgImage />
                            ) : LoggedInUserInfo?.USER_CATEGORY === "HYBRID" ? (
                                <SvgHybridImage />
                            ) : LoggedInUserInfo?.USER_CATEGORY === "ZERO-EXPORT" ? (
                                <Load1SvgImage />
                            ) : LoggedInUserInfo?.USER_CATEGORY === "SOLAR-GRID" ? (
                                <SingleSolarGrid />
                            ) : LoggedInUserInfo?.USER_CATEGORY === "SOLAR-LOAD" ? (
                                <SingleSolarLoad />
                            ) :
                                (
                                    <SvgImage1 />
                                )
                            }




                        </Box>
                    </Container>



                </Grid>





                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                        {/* First Card */}
                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >
                            <MainSlider />
                        </Stack>

                        {/* Second Card */}
                        {/* <Stack component={Card} p={spacing(1)} sx={{ height: '16rem', overflow: 'hidden' }}>
                            
                            <Tab4MonthlyEnergy />

                        </Stack> */}
                        <Tab4MonthlyEnergy />

                    </Stack>


                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={spacing(0)} style={{ marginTop: '.4rem' }}>

                    <Stack
                        component={Card}
                        p={spacing(1)}
                        sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(1) }}
                    >

                        <PlantEnergy />
                    </Stack>



                </Grid>
                {/* //PRBOTTOM CHART */}

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '0px', overflow: 'hidden' }}>
                        <PrBottomChart />

                    </Stack>


                </Grid>


            </Grid>

            <BottomSlider />

        </>
    );
}


export default memo(DashboardTap4Content)